import React from 'react';

const StatusIcon = ({ size = 20, color="#6A6A6A" }: { size?: number ; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4919 6.24863C17.154 7.38803 17.5026 8.6824 17.5023 10.0002M6.24766 16.4929C5.11037 15.8341 4.16534 14.889 3.50651 13.7518M13.7508 3.50749C12.6114 2.84541 11.317 2.49679 9.99922 2.49707M9.99922 17.5033C12.6771 17.4982 15.1502 16.0692 16.4919 13.7518M6.24766 3.50749C3.93017 4.84925 2.5012 7.32232 2.49609 10.0002M14.1676 10.0002C14.1676 12.3023 12.3014 14.1686 9.99922 14.1686C7.69707 14.1686 5.83082 12.3023 5.83082 10.0002C5.83082 7.69805 7.69707 5.83179 9.99922 5.83179C12.3014 5.83179 14.1676 7.69805 14.1676 10.0002Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StatusIcon;
